import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface IInitialState {
  countMessages: number;
}

const initialState: IInitialState = {
  countMessages: 0,
};

const ordersSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setCountMessages: (state, action: PayloadAction<any>) => {
      state.countMessages = action.payload;
    },
  },
});

export const { setCountMessages } = ordersSlice.actions;

export default ordersSlice.reducer;
